<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path d="M9.81507 9.81429V7.5H11.1849V9.81429H13.5V11.1857H11.1849V13.5H9.81507V11.1857H7.5V9.81429H9.81507Z" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.89943 17.3211C11.6498 17.4676 13.3899 16.9383 14.7622 15.8419L19.0949 20.1762C19.1659 20.2472 19.2502 20.3035 19.3429 20.3419C19.4357 20.3803 19.5351 20.4001 19.6355 20.4001C19.7359 20.4001 19.8354 20.3803 19.9281 20.3419C20.0209 20.3035 20.1052 20.2472 20.1762 20.1762C20.2472 20.1052 20.3035 20.0209 20.3419 19.9281C20.3803 19.8354 20.4001 19.7359 20.4001 19.6355C20.4001 19.5351 20.3803 19.4357 20.3419 19.3429C20.3035 19.2502 20.2472 19.1659 20.1762 19.0949L15.8419 14.7622C16.9383 13.3899 17.4676 11.6498 17.3211 9.89943C17.1746 8.14904 16.3635 6.52118 15.0543 5.35017C13.745 4.17916 12.0371 3.55388 10.2813 3.60276C8.5255 3.65164 6.85503 4.37096 5.613 5.613C4.37096 6.85503 3.65164 8.5255 3.60276 10.2813C3.55388 12.0371 4.17916 13.745 5.35017 15.0543C6.52118 16.3635 8.14904 17.1746 9.89943 17.3211ZM15.4106 12.5178C15.6792 11.8693 15.8175 11.1742 15.8175 10.4722C15.8175 9.05459 15.2543 7.695 14.2519 6.69257C13.2495 5.69014 11.8899 5.12698 10.4722 5.12698C9.05459 5.12698 7.695 5.69014 6.69257 6.69257C5.69014 7.695 5.12698 9.05459 5.12698 10.4722C5.12698 11.1742 5.26524 11.8693 5.53387 12.5178C5.80249 13.1663 6.19622 13.7555 6.69257 14.2519C7.18893 14.7483 7.77818 15.142 8.4267 15.4106C9.07521 15.6792 9.77029 15.8175 10.4722 15.8175C11.1742 15.8175 11.8693 15.6792 12.5178 15.4106C13.1663 15.142 13.7555 14.7483 14.2519 14.2519C14.7483 13.7555 15.142 13.1663 15.4106 12.5178Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconShowMore',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
